import React, { useMemo } from "react";

type EmojiFireworksProps = {
  active: boolean;
  count?: number;
  emojis?: string[];
};

export const EmojiFireworks: React.FC<EmojiFireworksProps> = ({
  active,
  count = 100,
  emojis = ["⭐", "❤️", "💙", "⚡️", "🌟", "✨", "🍭", "🦄", "🦊", "👋"],
}) => {
  const particles = useMemo(() => {
    const list: { id: number; emoji: string; angle: number; velocity: number; delay: number }[] = [];
    for (let i = 0; i < count; i++) {
      const emoji = emojis[Math.floor(Math.random() * emojis.length)];
      const angle = i * (360 / count) + Math.random() * 10;
      const velocity = 15 + Math.random() * 10;
      const delay = Math.random() * 1 + 0.3;
      list.push({ id: i, emoji, angle, velocity, delay });
    }
    return list;
  }, [count, emojis]);

  if (!active) return null;

  return (
    <div className="salute-animation">
      {particles.map((p) => (
        <div
          key={p.id}
          className="firework-particle"
          style={{
            ...( { "--angle": `${p.angle}deg`, "--velocity": `${p.velocity}`, "--delay": `${p.delay}s` } as React.CSSProperties ),
          }}
        >
          {p.emoji}
        </div>
      ))}
    </div>
  );
};


